<div mat-dialog-content>
  <div class="mt-3" *ngIf="!pedidoEmailRealizado; else confirmacao">
    <h3>Deseja enviar o e-mail associado a está ação?</h3>
    <button (click)="enviarEmail(); pedidoEmailRealizado = true" class="btn btn-block  mb-2 text-uppercase"
      [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()">enviar e-mail
    </button>
    <button (click)="close()" class="btn btn-block mb-2 text-uppercase"
      [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()">voltar
    </button>
  </div>
  <ng-template #confirmacao>
    <div class="mt-3">
      <h3>Solicitação de envio de e-mail realizada.</h3>
      <button [mat-dialog-close] class="btn btn-block  mb-2 text-uppercase"
        [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()">Fechar
      </button>
    </div>
  </ng-template>
</div>
